import { render, staticRenderFns } from "./ValidatedTextarea.vue?vue&type=template&id=0135ac3a&"
import script from "./ValidatedTextarea.vue?vue&type=script&lang=ts&"
export * from "./ValidatedTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports